<template>
    <div class="d-block mt-5">
        <v-row class="mt-4" v-if="!disabled">
            <v-btn color="primary" small tile @click="addRow" class="ms-3">
                {{ $t('InsertQuestion') }}
                <v-icon class="ms-2">mdi-plus-box</v-icon>
            </v-btn>
            <v-btn color="primary" class="ms-3" small tile @click="add" v-if="questions">
                {{ $t('InsertColumn') }}
                <v-icon class="ms-2">mdi-table-column-plus-after</v-icon>
            </v-btn>
        </v-row>
        <v-row>
            <v-col class="col-12">
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th v-for="(head, headerIndex) in headers" :key="headerIndex" :class="{ 'text-start': headerIndex == 0 , 'text-center': headerIndex > 0  }">
                                    <span>{{head.name}}</span>
                                    <v-icon v-if="!disabled && head.removable" dense small color="primary" class="ms-2" @click="() => editColumn(headerIndex)">mdi-pencil</v-icon>
                                    <v-icon v-if="!disabled && head.removable" dense small color="error" class="ms-2" @click="() => removeColumn(headerIndex)">mdi-delete</v-icon>

                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,rowIndex) in questions" :key="rowIndex">
                                <td v-for="(column, columnIndex) in headers" :key="columnIndex">
                                    <span v-if="columnIndex == 0">{{item.questionAr}}</span>
                                    <v-radio v-else disabled class="d-block text-center"></v-radio>
                                </td>
                                <td>
                                    <v-icon v-if="!disabled" color="primary" small @click="editRow(rowIndex)">mdi-pencil</v-icon>
                                    <v-icon v-if="!disabled" color="error" small class="mx-3" @click="removeRow(rowIndex)">mdi-delete</v-icon>
                                </td>

                            </tr>
                        </tbody>
                    </template>

                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>

            <CommonDialog v-model="dialog" v-if="dialog" :fullscreen="false" width="25%" :title="columnDialogTitle" show-action-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="columnName" :label="$t('Answer')" />
                        </v-col>
                    </v-row>
                </v-container>

                <template v-slot:actions>
                    <v-btn color="primary" class="white--text" tile v-if="editColumnFlag === 0" small @click="addColumn">
                        {{ $t("Add") }}
                    </v-btn>
                    <v-btn color="primary" class="white--text" tile v-if="editColumnFlag === 1" small @click="addColumn">
                        {{ $t("Edit") }}
                    </v-btn>
                    <v-btn color="error" class="white--text" tile small @click="dialog = false">
                        {{ $t("Cancel") }}
                    </v-btn>
                </template>
            </CommonDialog>
        </v-row>
        <v-row>
            <CommonDialog v-model="questionDialog" v-if="questionDialog" :fullscreen="false" width="25%" :title="questionDialogTitle" show-action-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="questionName" :label="$t('Question')" />
                        </v-col>
                    </v-row>
                </v-container>

                <template v-slot:actions>
                    <v-btn color="primary" class="white--text" tile v-if="editRowFlag === 0" small @click="addNewQuestion">
                        {{ $t("Add") }}
                    </v-btn>
                    <v-btn color="primary" class="white--text" tile v-if="editRowFlag === 1" small @click="addNewQuestion">
                        {{ $t("Edit") }}
                    </v-btn>
                    <v-btn color="error" class="white--text" tile small @click="questionDialog = false">
                        {{ $t("Cancel") }}
                    </v-btn>
                </template>
            </CommonDialog>
        </v-row>
    </div>

</template>

<script>
    import VTextField from '@/components/controls/VTextField.vue'
    import CommonDialog from '@/components/controls/CommonDialog'

    export default {
        components: {
            VTextField, CommonDialog
        },

        props: {

            value: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: function () {
                    return this.$t('BipolarMatrix')
                }
            },
        },

        data() {
            return {
                dialog: false,
                questionDialog: false,
                questionDialogTitle: this.$t('AddQuestion'),
                columnDialogTitle: this.$t('AddAnswer'),
                index: 0,
                nameRules: [(v) => !!v || this.$t('RequiredField')],
                loading: false,
                columnName: '',
                questionName: '',
                headers: [{ name: this.$t('Question'), removable: false }],
                questions: this.value,
                editRowFlag: 0,
                selectedRowIndex: 0,
                editColumnFlag: 0,
                selectedColumnIndex: 0

            }
        },

        mounted() {
            if (this.questions) {
                if (this.questions.length > 0) {
                    for (var j = 0; j < this.questions[0].options.length; j++) {
                        this.headers.push({ name: this.questions[0].options[j].optionAr, removable: true })
                    }
                }
                this.index = this.headers.length
            }
        },

        methods: {

            add() {
                this.dialog = true
            },
            editColumn(index) {
                this.columnDialogTitle = this.$t('Edit')
                this.dialog = true
                var selectedColumn = this.headers[index]
                if (selectedColumn) {
                    this.columnName = selectedColumn.name
                    this.editColumnFlag = 1
                    this.selectedColumnIndex = index
                }
            },
            addColumn() {
                if (this.editColumnFlag == 1) {
                    this.headers[this.selectedColumnIndex].name = this.columnName
                    this.headers[this.selectedColumnIndex].name = this.columnName
                    for (var i = 0; i < this.questions.length; i++) {
                        this.questions[i].options[this.selectedColumnIndex - 1].optionAr = this.columnName
                        this.questions[i].options[this.selectedColumnIndex - 1].optionEn = this.columnName
                    }
                    this.editColumnFlag = 0
                    this.selectedColumnIndex = 0
                } else {
                    if (this.columnName) {
                        this.headers.push({ name: this.columnName, removable: true })
                        var option = { optionAr: this.columnName, optionEn: this.columnName }
                        for (var i = 0; i < this.questions.length; i++) {
                            this.questions[i].options.push(option)
                        }
                    }
                    this.index++
                }
                this.columnName = ''
                this.dialog = false

            },
            remove() {
                this.headers.pop()
                this.questions.forEach(item => { item.options.pop() })
                this.index--
            },
            removeColumn(index) {
                this.headers = this.headers.slice(0, index).concat(this.headers.slice(index + 1))
                for (var i = 0; i < this.questions.length; i++) {
                    var options = this.questions[i].options
                    options = options.slice(0, index - 1).concat(options.slice(index))
                    this.questions[i].options = options

                }
                this.index--
            },
            addRow() {
                this.questionDialog = true
                this.questionDialogTitle = this.$t('AddQuestion')

            },
            addNewQuestion() {

                if (this.editRowFlag == 1) {
                    this.questions[this.selectedRowIndex].questionAr = this.questionName
                    this.questions[this.selectedRowIndex].questionEn = this.questionName
                    this.editRowFlag = 0
                    this.selectedRowIndex = 0
                } else {
                    if (this.questionName) {
                        this.questions.push({ questionAr: this.questionName, questionEn: this.questionName, options: [] })
                        this.addOptions()
                    }
                }
                this.questionName = ''
                this.questionDialog = false

            },
            removeRow(index) {
                this.questions = this.questions.slice(0, index).concat(this.questions.slice(index + 1))
            },
            editRow(index) {
                this.questionDialogTitle = this.$t('Edit')
                this.questionDialog = true
                var selectedQuestion = this.questions[index]
                if (selectedQuestion) {
                    this.questionName = selectedQuestion.questionAr
                    this.editRowFlag = 1
                    this.selectedRowIndex = index
                }

            },
            addOptions() {
                let firstElement = this.questions[0]
                let lastElement = this.questions.slice(-1)[0]
                for (var i = 0; i < firstElement.options.length; i++) {
                    lastElement.options.push(firstElement.options[i])
                }
            }
        }
    }
</script>

<style scoped>
    tbody tr:nth-of-type(2n) { background-color: #eceded !important; }
</style>